module.exports = __webpack_public_path__ + "img/ht_icon_upload_cloud_2_line.b8393346.svg";